<!-- Admin Home -->
<div class="container" *ngIf="auth.isSuperAdmin && !resetMode">
    <div class="card">
        <div class="card-header text-center">
            <h1>Super Administrator Home</h1>
        </div>

        <div class="card-body">

            <!-- All Users -->
            <div class="admin-row">
                <h3>All Users:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/all-users'">View All Users</button>
            </div>

            <!-- All Admins -->
            <div class="admin-row">
                <h3>All Admins:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/all-admins'">View All Admins</button>
            </div>

            <!-- RentWise Evaluations -->
            <div class="admin-row">
                <h3>RentWise Evaluations:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/all-evaluations'">RentWise Evaluations</button>
            </div>

            <!-- Properties -->
            <div class="admin-row">
                <h3>Properties Information:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/hp-properties'">Housing Providers Properties</button>
            </div>

            <!-- Challenges -->
            <div class="admin-row">
                <h3>Property Challenge Requests:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/challenges'">
                  <span>Challenges</span>
                  <span class="count" *ngIf="challengesCount !== undefined"> ({{challengesCount}})</span>
                </button>
            </div>

            <!-- Client Properties -->
            <div class="admin-row">
                <h3>Client Properties Information:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/client-properties'">Client Properties</button>
            </div>

            <!-- Edit Agencies -->
            <div class="admin-row">
                <h3>Edit Agencies:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/edit-agency'">Edit Agencies</button>
            </div>

            <!-- Create new Agency -->
            <div class="admin-row">
                <h3>Create New Agency:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/new-agency'">Add Agency</button>
            </div>

            <!-- Courses -->
            <div class="admin-row">
                <h3>Manage Courses Content:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/admin-courses'">Courses</button>
            </div>

            <!-- Quiz Questions -->
            <div class="admin-row">
                <h3>Manage Quiz Questions:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/quiz-questions'">Quiz Questions</button>
            </div>

            <!-- Reset Password -->
            <div class="admin-row">
                <h3>Reset Password:</h3>
                <button type="button" class="btn waves-dark" (click)="resetMode = !resetMode">Reset Password</button>
            </div>

            <!-- Banned List -->
            <div class="admin-row">
                <h3>Banned List of Emails:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/admin-banned-list'">Banned List</button>
            </div>
        </div>
    </div>
</div>

<!-- Agency Admins  -->
<div class="container" style="margin-top: 50px;" *ngIf="!auth.isSuperAdmin && !resetMode">
    <div class="card">
        <div class="card-header text-center">
            <h1>Administrator - {{ auth.agencyInfo.agencyName }}</h1>
        </div>
        <div class="card-body">


            <!-- View user Details -->
            <div class="admin-row">
                <h3>View Users</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/rentwise-users'">View Users Under Agency</button>
            </div>

            <!-- View RentWise Evaluations -->
            <div class="admin-row">
                <h3>View RentWise Evaluations:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/admin/rentwise-evaluations'">View Evaluations</button>
            </div>

            <!-- Invite New Admin -->
            <div class="admin-row">
                <h3>Reset Password:</h3>
                <button type="button" class="btn waves-dark" (click)="resetMode = !resetMode">Reset Password</button>
            </div>
        </div>
    </div>
</div>

<!-- Reset Password Mode  -->
<section *ngIf=resetMode>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" class="" (submit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
            <h1 class="text-center">Reset Password</h1>

            <!-- Input Fields -->
            <div class="col-md-12">

                <!-- Input Row-->
                <div class="row mt-2">

                    <!-- Password -->
                    <div class="col-md-12">
                        <label class="required-field">New Password</label>
                        <input type="password" id="password" class="form-control mb-2" placeholder="Password" [(ngModel)]="update.password" name="password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" password required minlength="6">

                        <!-- Invalid Password -->
                        <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="password.errors!.required">Password is required</div>
                            <div class="mb-1 text-center" *ngIf="password.errors!.minlength">Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row-->
                <div class="row mt-2">

                    <!-- Confirm Password -->
                    <div class="col-md-12">
                        <label class="required-field">Confirm New Password</label>
                        <input type="password" id="confirmPassword" class="form-control mb-2" placeholder="Repeat Password" [(ngModel)]="update.confirmPassword" name="confirmPassword" #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }"
                            password required validateEqual="password" minlength="6">

                        <!-- Invalid Confirm Password -->
                        <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" [hidden]="confirmPassword.valid || (confirmPassword.pristine && !f.submitted)">Password and Confirm Password need to match</div>
                            <div class="mb-1 text-center" *ngIf="confirmPassword.errors!.minlength">Confirm Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Submit -->
            <div class="text-center">
                <button type="submit" class="my-4 btn">Submit</button>
            </div>
        </form>
    </div>
</section>
